/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_A3Inputs */

const es_marketplace_seo_spain_faq_a3 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El patrón navega la embarcación y conoce la zona. Combustible, comida o material de snorkel dependen de cada anuncio: revísalo antes de reservar y pregunta al armador si tienes dudas.`)
};

const gl_marketplace_seo_spain_faq_a3 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O patrón navega a embarcación e coñece a zona. Combustible, comida ou material de snorkel dependen de cada anuncio: revísa antes de reservar e pregunta ao armador se tes dúbidas.`)
};

const en_marketplace_seo_spain_faq_a3 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The skipper navigates and knows the area. Fuel, food or snorkelling gear depend on each listing — check before booking and ask the owner if unsure.`)
};

/**
* | output |
* | --- |
* | "The skipper navigates and knows the area. Fuel, food or snorkelling gear depend on each listing — check before booking and ask the owner if unsure." |
*
* @param {Marketplace_Seo_Spain_Faq_A3Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_a3 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_A3Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_A3Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_a3(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_a3(inputs)
	return es_marketplace_seo_spain_faq_a3(inputs)
});